import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, UserService } from '../..';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';

@Injectable()
export class KhachHangTreoThaoService {

  constructor(private router: Router, private api: ApiService, private userService: UserService) { }
  //APIURL = "api/ImportFileXmlToOracle/";
  APIURL = "api/ExcuteOracle";



  public Get_BAOCAO_TT_TREOTHAO(TUNGAY, DENNGAY, pagenum, numrecs) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHACHHANG.P_LAYDS_BAOCAO_TT_TREOTHAO" }),
      para: JSON.stringify({
        v_DATEFROM: TUNGAY,

        v_DATETO: DENNGAY,
        v_pagenum: pagenum,
        v_numrecs: numrecs

      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  excel_ls_thaycongto(TUNGAY, DENNGAY, tenDanhmuc) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "chungloai", "label": "Chủng loại", "horizontalalignment": "left" },
      { "name": "ngaytreo", "label": "Ngày treo", "horizontalalignment": "left" },
      { "name": "ngaythao", "label": "Ngày tháo", "horizontalalignment": "left" },
      { "name": "tu_ngoai", "label": "TU", "horizontalalignment": "center" },
      { "name": "ti_ngoai", "label": "TI", "horizontalalignment": "center" },
      { "name": "hsn_ngoai", "label": "HSN", "horizontalalignment": "center" },
      { "name": "treothaott", "label": "Trạng thái", "horizontalalignment": "center" },
    ]
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tenDanhmuc + "_" + strDate + ".xlsx";
    var param = {
      config: JSON.stringify({ namesql: "PKG_KHACHHANG.P_LAYDS_BAOCAO_TT_TREOTHAO" }),
      para: JSON.stringify({
        v_DATEFROM: TUNGAY,
        v_DATETO: DENNGAY,
        v_pagenum: 0,
        v_numrecs: 10000000
      }),
      title: "BÁO CÁO LỊCH SỬ THAY CÔNG TƠ",
      header: tenDanhmuc + " - Ngày: " + strDate + "," + tenDanhmuc + " - Ngày: " + strDate,
      filename: fileName,
      sheets: "BÁO CÁO LỊCH SỬ THAY CÔNG TƠ",
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, fileName);
  }

  save_ls_thaycongto(TUNGAY, DENNGAY, tenDanhmuc, mataikhoan, danhmucid) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "chungloai", "label": "Chủng loại", "horizontalalignment": "left" },
      { "name": "ngaytreo", "label": "Ngày treo", "horizontalalignment": "left" },
      { "name": "ngaythao", "label": "Ngày tháo", "horizontalalignment": "left" },
      { "name": "tu_ngoai", "label": "TU", "horizontalalignment": "center" },
      { "name": "ti_ngoai", "label": "TI", "horizontalalignment": "center" },
      { "name": "hsn_ngoai", "label": "HSN", "horizontalalignment": "center" },
      { "name": "treothaott", "label": "Trạng thái", "horizontalalignment": "center" },
    ]
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tenDanhmuc + "_" + strDate + ".xlsx";
    var param = {
      config: JSON.stringify({ namesql: "PKG_KHACHHANG.P_LAYDS_BAOCAO_TT_TREOTHAO" }),
      para: JSON.stringify({
        v_DATEFROM: TUNGAY,
        v_DATETO: DENNGAY,
        v_pagenum: 0,
        v_numrecs: 10000000
      }),
      title: "BÁO CÁO LỊCH SỬ THAY CÔNG TƠ",
      header: tenDanhmuc + " - Ngày: " + strDate + "," + tenDanhmuc + " - Ngày: " + strDate,
      filename: fileName,
      sheets: "BÁO CÁO LỊCH SỬ THAY CÔNG TƠ",
      columns: cols,
      data: "",
      mataikhoan: mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 8,
      tenbaocao: "BÁO CÁO LỊCH SỬ THAY CÔNG TƠ",
    };

    return this.api.Excute("api/saveExcel", param);
  }



  //Lấy danh sách loại công tơ
  public layDanhSachLoaiCongTo() {
    var param = {
      "config": '{"namesql":"PKG_KHAIBAOKHACHHANG.P_LAYDS_LOAICONGTO"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  //Lấy danh sách loại công tơ
  public layDSCauhinhcanhbao() {
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_LAYDS_CAUHINHCANHBAO"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  //Lấy danh sách dự án
  public layDSDuan() {
    var param = {
      "config": '{"namesql":"PKG_DUAN.P_LAYDS_DUAN"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  public layDS_KH(danhmucid, mataikhoan, thanhly, trangthai, lockhachhang, sotrang, sodong) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAYDS_KHACHHANG" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_mataikhoan: mataikhoan,
        v_thanhly: thanhly,
        v_trangthai: trangthai,
        v_lockhachhang: lockhachhang,
        v_ip: "",
        v_sotrang: sotrang,
        v_sodong: sodong,
      })
    };
    return this.api.Excute(this.APIURL, param);
  }


  public layTT_KH(meterid) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAY_TT_KHACHHANG" }),
      para: JSON.stringify({
        v_meterid: meterid
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  public layTT_Cto(meterid) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAYDS_CTO_KHACHHANG" }),
      para: JSON.stringify({
        v_meterid: meterid
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  public layTT_DCU(meterid) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAY_TT_DCU" }),
      para: JSON.stringify({
        v_meterid: meterid
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  public suaTT_KH(
    meterid,
    danhmucid,
    makhachhang,
    madiemdo,
    tenkhachhang,
    diachi,
    macongto,
    macot,
    matram,
    masoghi,
    sapxep,
    donvinhan,
    ghichu,
    maduan,
    marepeater,
    congsuattram,
    ucao,
    uha,
    kenh,
    matdien,
    nghiemthu,
    macauhinhcanhbao,
    loaipha,
    mataikhoan,
    ip


  ) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_SUA_THONGTIN_KHACHHANG" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_danhmucid: danhmucid,
        v_makhachhang: makhachhang,
        v_madiemdo: madiemdo,
        v_tenkhachhang: tenkhachhang,
        v_diachi: diachi,
        v_macongto: macongto,
        v_macot: macot,
        v_matram: matram,
        v_masoghi: masoghi,
        v_sapxep: sapxep,
        v_donvinhan: donvinhan,
        v_ghichu: ghichu,
        v_maduan: maduan,
        v_marepeater: marepeater,
        v_congsuattram: congsuattram,
        v_ucao: ucao,
        v_uha: uha,
        v_kenh: kenh,
        v_matdien: matdien == true ? 1 : 0,
        v_nghiemthu: nghiemthu,
        v_macauhinhcanhbao: macauhinhcanhbao,
        v_loaipha: loaipha,
        v_mataikhoan: mataikhoan,
        v_cn_id: 0,
        v_nsx_id: 0
      })
    };

    return this.api.Excute(this.APIURL, param);
  }

  public thanhLy_DD(meterid, mataikhoan, ip) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_THANHLY_KHACHHANG" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  public khoiphuc_thanhLy_DD(meterid, mataikhoan, ip) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_THANHLY_HUY_THANHLY" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  public suaTT_CT(
    meterid,
    socongto,
    tu,
    ti,
    hsn,
    loaicongto,
    matkhaucongto,
    matkhaucap2,
    outstation,
    loaiheso,
    hangso,
    offset,
    chiso_treo,
    chiso_thao,
    bt_treo,
    bt_thao,
    cd_treo,
    cd_thao,
    td_treo,
    td_thao,
    sg_treo,
    sg_thao,
    vc_treo,
    vc_thao,
    loai_module,
    mataikhoan,
    ip,) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_SUA_THONGTIN_CONGTO" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_socongto: socongto,
        v_tu: tu,
        v_ti: ti,
        v_hsn: hsn,
        v_loaicongto: loaicongto,
        v_matkhaucongto: matkhaucongto,
        v_matkhaucap2: matkhaucap2,
        v_outstation: outstation,
        v_loaiheso: loaiheso,
        v_hangso: hangso,
        v_offset: offset,
        v_chiso_treo: chiso_treo,
        v_chiso_thao: chiso_thao,
        v_bt_treo: bt_treo,
        v_bt_thao: bt_thao,
        v_cd_treo: cd_treo,
        v_cd_thao: cd_thao,
        v_td_treo: td_treo,
        v_td_thao: td_thao,
        v_sg_treo: sg_treo,
        v_sg_thao: sg_thao,
        v_vc_treo: vc_treo,
        v_vc_thao: vc_thao,
        v_loai_module: loai_module,
        v_mataikhoan: mataikhoan,
        v_ip: ip,
      })
    };

    return this.api.Excute(this.APIURL, param);
  }


  public thayCT(
    meterid,
    socongto_cu,
    socongto_moi,
    loaicongto,
    hangso,
    offset,
    chiso_treo,
    chiso_thao,
    bt_treo,
    bt_thao,
    cd_treo,
    cd_thao,
    td_treo,
    td_thao,
    sg_treo,
    sg_thao,
    vc_treo,
    vc_thao,
    loai_module,
    mataikhoan,
    ip,
  ) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_THAY_CONGTO" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_socongto_cu: socongto_cu,
        v_socongto_moi: socongto_moi,
        v_loaicongto: loaicongto,
        v_hangso: hangso,
        v_offset: offset,
        v_chiso_treo: chiso_treo,
        v_chiso_thao: chiso_thao,
        v_bt_treo: bt_treo,
        v_bt_thao: bt_thao,
        v_cd_treo: cd_treo,
        v_cd_thao: cd_thao,
        v_td_treo: td_treo,
        v_td_thao: td_thao,
        v_sg_treo: sg_treo,
        v_sg_thao: sg_thao,
        v_vc_treo: vc_treo,
        v_vc_thao: vc_thao,
        v_loai_module: loai_module,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };
    return this.api.Excute(this.APIURL, param);
  }


  public suaTT_DCU(
    meterid,
    imei,
    congserver,
    loaithietbi,
    version,
    loaisim,
    sosim,
    loaiadapter,
    loaiangten,
    kinhdo,
    vido,
    csq,
    tenthietbi,
    mataikhoan,
    ip
  ) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_SUA_THIETBI" }),
      para: JSON.stringify({
        v_imei: imei,
        v_congserver: congserver,
        v_loaithietbi: loaithietbi,
        v_version: version,
        v_loaisim: loaisim,
        v_sosim: sosim,
        v_loaiadapter: loaiadapter,
        v_loaiangten: loaiangten,
        v_kinhdo: kinhdo,
        v_vido: vido,
        v_csq: csq,
        v_tenthietbi: tenthietbi,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  public thay_DCU(meterid, socongto, imei_cu, imei_moi, congserver, mataikhoan, ip) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_THAY_THIETBI" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_socongto_cu: socongto,
        v_imei_cu: imei_cu,
        v_imei_moi: imei_moi,
        v_congserver: congserver,
        v_mataikhoan: mataikhoan,
        v_ip: ip,
      })
    };
    return this.api.Excute(this.APIURL, param);
  }


  public themKH(
    danhmucid,
    makhachhang,
    madiemdo,
    imei,
    socongto,
    tenkhachhang,
    diachi,
    macongto,
    macot,
    matram,
    masoghi,
    sapxep,
    donvinhan,
    ghichu,
    maduan,
    marepeater,
    kenh,
    congsuattram,
    ucao,
    uha,
    macauhinhcanhbao,
    matdien,
    loaipha,
    loaicongto,
    outstation,
    matkhaucongto,
    matkhaucongto2,
    tu,
    ti,
    hsn,
    loaiheso,
    hangso,
    offset,
    cstreo,
    bt_treo,
    cd_treo,
    td_treo,
    sg_treo,
    vc_treo,
    congserver,
    loaimodulerf,
    mataikhoan,
    ip,
  ) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_THEM_KHACHHANG" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_makhachhang: makhachhang,
        v_madiemdo: madiemdo,
        v_imei: imei,
        v_socongto: socongto,
        v_tenkhachhang: tenkhachhang,
        v_diachi: diachi,
        v_macongto: macongto,
        v_macot: macot,
        v_matram: matram,
        v_masoghi: masoghi,
        v_sapxep: sapxep,
        v_donvinhan: donvinhan,
        v_ghichu: ghichu,
        v_maduan: maduan,
        v_marepeater: marepeater,
        v_kenh: kenh,
        v_congsuattram: congsuattram,
        v_ucao: ucao,
        v_uha: uha,
        v_macauhinhcanhbao: macauhinhcanhbao,
        v_matdien: matdien == true ? 1 : 0,
        v_loaipha: loaipha,
        v_loaicongto: loaicongto,
        v_outstation: outstation,
        v_matkhaucongto: matkhaucongto,
        v_matkhaucongto2: matkhaucongto2,
        v_tu: tu,
        v_ti: ti,
        v_hsn: hsn,
        v_loaiheso: loaiheso,
        v_hangso: hangso,
        v_offset: offset,
        v_cstreo: cstreo,
        v_bt_treo: bt_treo,
        v_cd_treo: cd_treo,
        v_td_treo: td_treo,
        v_sg_treo: sg_treo,
        v_vc_treo: vc_treo,
        v_congserver: congserver,
        v_loaimodulerf: loaimodulerf,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };
    return this.api.Excute(this.APIURL, param);
  }



  getDsDDo_EXCEL(danhmucid, mataikhoan, thanhly, trangthai, lockhachhang, sotrang, sodong, title, ngay, filename) {
    let cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
      { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "trangthai", "label": "Trạng thái", "horizontalalignment": "left" },
      { "name": "thoidiemgannhat", "label": "Thời điểm có dữ liệu", "horizontalalignment": "center" },
      { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
      { "name": "tentram", "label": "Tên trạm", "horizontalalignment": "left" },
      { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
      { "name": "marepeater", "label": "Repeater", "horizontalalignment": "left" },
      { "name": "ctydienluc", "label": "Công ty điện lực", "horizontalalignment": "left" },
      { "name": "dienluc", "label": "Điện lực", "horizontalalignment": "left" },
      { "name": "congserver", "label": "Port", "horizontalalignment": "left" },
      { "name": "simcard", "label": "SIMCARD", "horizontalalignment": "left" },
    ];

    if (thanhly == 1)
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
        { "name": "tentram", "label": "Tên trạm", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "ngaythanhly", "label": "Ngày thanh lý", "horizontalalignment": "center" },
        { "name": "simcard", "label": "SIMCARD", "horizontalalignment": "left" },
      ];
    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAYDS_KHACHHANG" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_mataikhoan: mataikhoan,
        v_thanhly: thanhly,
        v_trangthai: trangthai,
        v_lockhachhang: lockhachhang,
        v_ip: "",
        v_sotrang: sotrang,
        v_sodong: sodong,
      }),
      title: title,
      header: "Ngày: " + ngay,
      filename: filename,
      sheets: thanhly == 0 ? "Thông tin điểm đo" : "Thông tin điểm đo thanh lý",
      columns: cols,
      data: ""
    };


    return this.api.downloadFile("api/ExportExcel", param, filename);
  }

  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File, mataikhoan, ip) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    formData.append('mataikhoan', mataikhoan);
    formData.append('ip', ip);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/Treothao/UploadExcelReturnJson", formData, options);
  }

  public thanhlyDs(lst_maddo, mataikhoan, ip) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_THANHLY_DS_KH" }),
      para: JSON.stringify({
        v_lst_maddo: lst_maddo,
        v_mataikhoan: mataikhoan,
        v_ip: ip,
      })
    };
    return this.api.Excute(this.APIURL, param);
  }


}




// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/nhap-thong-tin-kh/khach-hang-treo-thao/khachhangtreothao.service.ts